import { Box, MenuItem, Typography } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import {
  CustomButton,
  CustomSelect,
  HorizontalForm,
  VerticalForm,
} from '../../../common/components';

/**
 * Filtros para el modulo de estadisticas gerenciales.
 * @param {Object} props - Props del componente.
 * @param {string} props.reportType - Tipo de reporte seleccionado.
 * @param {Array<{label: string, value: string}>} props.reportOptions - Opciones del selector.
 * @param {boolean} props.loading - Estado de carga.
 * @param {string|null} props.error - Mensaje de error.
 * @param {Object|null} props.header - Header de respuesta.
 * @param {Function} props.onReportTypeChange - Handler de cambio de reporte.
 * @param {Function} props.onReload - Handler de recarga.
 * @param {Function} props.onDownloadPdf - Handler de descarga PDF.
 * @param {boolean} props.disableDownload - Deshabilita descarga cuando no hay data.
 * @returns {JSX.Element} Barra de filtros.
 */
const GerencialesFilters = ({
  reportType,
  reportOptions,
  loading,
  error,
  header,
  onReportTypeChange,
  onReload,
  onDownloadPdf,
  disableDownload,
}) => {
  return (
    <HorizontalForm>
      <CustomSelect
        label="Tipo de reporte"
        size="medium"
        value={reportType}
        onChange={onReportTypeChange}
        sx={{ maxWidth: 440 }}
      >
        {reportOptions.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </CustomSelect>
      <CustomButton
        variant="warning"
        onClick={onReload}
        disabled={loading}
        buttonIcon={RefreshIcon}
        sx={{ mt: 1.5, ml: 2 }}
      >
        Actualizar
      </CustomButton>
      <VerticalForm withBorder={false} sx={{ mt: -3.5}}>
        {header?.updated_at_date && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
            Actualizado: {header.updated_at_date}
          </Typography>
        )}
        {header?.total_contracts != null && (
          <Typography variant="body2" color="text.secondary">
            Total contratos: {header.total_contracts}
          </Typography>
        )}
        {error && (
          <Typography variant="body2" color="error">
            {error}
          </Typography>
        )}
      </VerticalForm>
      <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'block' } }} />
      <CustomButton
        variant="base"
        onClick={onDownloadPdf}
        disabled={loading || disableDownload}
        buttonIcon={PictureAsPdfIcon}
        sx={{ mt: 1.5 }}
      >
        Descargar PDF
      </CustomButton>
    </HorizontalForm>
  );
};

export default GerencialesFilters;
